import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=06df7d5a&scoped=true&"
import script from "./Vacancy.vue?vue&type=script&lang=js&"
export * from "./Vacancy.vue?vue&type=script&lang=js&"
import style0 from "./Vacancy.vue?vue&type=style&index=0&id=06df7d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df7d5a",
  null
  
)

export default component.exports